/** ***
------------------------------------------------------------------------
WHITELIST PAGE
------------------------------------------------------------------------
  "customWhitelists": [{ 
      "key": "userQuery", 
      "value": "{'w','who'}", 
      "field": "sourceProcessName", 
      "ruleIds": ["88", "89", "90"] 
      }]
** ***/
const whitelistMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Whitelist Name',
        label: 'Name',
        'min-width': 200,
        sortable: true,
        name: 'key'
      },
      {
        datatype: 'string',
        description: 'Rule Type',
        label: 'Type',
        'min-width': 150,
        sortable: true,
        name: 'field',
        display: 'iconAndText',
        displayKey: [
          {
            key: 'remoteHost',
            display: 'IP Address',
            color: '#77dab4',
            textColor: '#008044',
            icon: ''
          },
          {
            key: 'sourceProcessName',
            display: 'Process',
            color: '#c6cbd2',
            textColor: '#6a6e75',
            icon: ''
          }
        ]
      },
      {
        datatype: 'number',
        description: 'Whitelist Values',
        label: 'Values',
        'min-width': 100,
        sortable: true,
        name: 'valuesCount',
        display: 'popup'
      },
      {
        datatype: 'number',
        description: 'Rules Applied To',
        label: 'Rules Applied To',
        'min-width': 100,
        sortable: true,
        name: 'rulesCount',
        display: 'popup'
      }
    ]
  }
}

export { whitelistMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/allowlist/whitelist-meta.js